import { pruneRequestCaches } from '@portals/fetch-api';
import { pruneProjectsApiCaches } from './prune-projects-api-caches';

export const pruneApiCaches = async () => {
  await pruneRequestCaches({});
  // sendApiCachePruneEvent(prunedCacheInfo);

  await pruneProjectsApiCaches();
};
